import { MouseEvent } from 'react';
import { trackEvent } from '../modules/analytics';
import { getAbsoluteUrl } from './formatUrl';
import {
  SupplierAnalyticsEvent,
  SupplierClickConfig,
} from '../types/analytics';

export const createSupplierAnalyticsData = (
  supplierName: string,
  href: string,
  currentPage: string,
  source: string
): SupplierAnalyticsEvent => ({
  supplierName,
  destinationUrl: getAbsoluteUrl(href),
  currentPage: getAbsoluteUrl(currentPage),
  source,
});

export const createSupplierClickHandler = (
  config: SupplierClickConfig,
  eventName: string
) => {
  return (event: MouseEvent) => {
    if (config.preventDefault) {
      event.preventDefault();
    }
    if (config.stopPropagation) {
      event.stopPropagation();
    }

    const analyticsData = createSupplierAnalyticsData(
      config.supplierName,
      config.href,
      config.currentPage,
      config.source
    );

    trackEvent(eventName, analyticsData);

    if (config.useWindowLocation) {
      window.location.href = config.href;
    }

    if (typeof config.onClickLink === 'function') {
      config.onClickLink(event as MouseEvent<HTMLAnchorElement>);
    }
  };
};
